import clientApi from '../../../api/clientApi';
import { Endpoints } from '../../../utility/constants';
import { handleError } from '.';

const CONTACT_MESSAGE = ' Please try again or contact support.';

export const getRoById = (repairOrderId) => async (dispatch) => {
  dispatch({ type: 'LOADING' });

  try {
    const roResponse = await clientApi.get(`${Endpoints.ros}/${repairOrderId}`);
    dispatch({
      type: 'SET_CURRENT_RO',
      data: roResponse.data,
    });
  } catch (error) {
    dispatch(handleError(error));
  } finally {
    dispatch({ type: 'LOADING_END' });
  }
};

export const getRoList = (params) => async (dispatch) => {
  dispatch({ type: 'LOADING' });
  const config = {
    params: {
      open: true,
      sortField: 'dateCreated',
      sortDirection: 'DESC',
      page: 1,
      pageLimit: 50,
      ...params,
    },
  };
  let response;
  try {
    response = await clientApi.get(Endpoints.ros, config);

    if (config.params.page === 1) {
      dispatch(receiveRoList(response.data.results));
    } else {
      dispatch(recieveMoreRoList(response.data.results));
    }
  } catch (error) {
    dispatch(handleError(error));
  } finally {
    return response;
  }
};

export const receiveRoList = (roList) => {
  return (dispatch) => {
    dispatch({ type: 'RECEIVE_RO_LIST', data: roList });
  };
};

export const recieveMoreRoList = (roList) => {
  return (dispatch) => {
    dispatch({ type: 'RECEIVE_MORE_RO_LIST', data: roList });
  };
};

export const getOpCodes = (params) => async (dispatch) => {
  dispatch({ type: 'GET_OP_CODES' });
  try {
    const response = await clientApi.get(Endpoints.opCodes, {
      params,
    });
    if (response.status === 200) {
      return response;
    } else throw new Error(`Failed to get Op. Codes.${CONTACT_MESSAGE}`);
  } catch (error) {
    dispatch(handleError(error));
    return [];
  }
};
